export default "__VITE_ASSET__Ch8evdk8__"